<template>
  <div>
    <label
      v-if="label"
      :for="name"
      class="mb-1 block text-xs font-medium text-background-fg/70"
    >
      {{ label }}
    </label>
    <BaseTextArea
      :model-value="inputValue"
      :placeholder="placeholder"
      :name="name"
      :has-error="hasError"
      :disabled="disabled"
      @blur="handleBlur"
      @change="handleChange"
    />
    <template v-if="hasError">
      <p class="mt-1 text-xs font-medium text-error">
        {{ errorMessage }}
      </p>
    </template>
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate"

const props = defineProps<{
  name: string
  label?: string
  placeholder?: string
  disabled?: boolean
}>()

const name = toRef(props, "name")

const {
  value: inputValue,
  errorMessage,
  handleBlur,
  handleChange,
  meta,
} = useField<string>(name, undefined, {
  syncVModel: false,
})

const hasError = computed(
  () => !!errorMessage.value && meta.touched
)
</script>
